angular
    .module('app')
    .component('segmentsList', {
        templateUrl: '/templates/pages/segments/segmentsList/segmentsList.html',
        controller: 'SegmentsListController',
        controllerAs: 'vm',
    });